import { render, staticRenderFns } from "./array-select.vue?vue&type=template&id=8b09b5e4"
import script from "./array-select.vue?vue&type=script&lang=js"
export * from "./array-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports